import { InstagramLogo, WhatsappLogo } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { getWhatsAppUrl } from './WhatsAppButton';

const Footer = () => {
  return (
    <footer className="bg-secondary border-t border-border/40 py-8 sm:py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center sm:text-left"
          >
            <h3 className="font-heading font-black text-xl sm:text-2xl text-foreground tracking-tight mb-2 sm:mb-3">
              POSTERLY
            </h3>
            <p className="text-muted-foreground text-xs sm:text-sm">
              Posters That Define You
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-center sm:text-left"
          >
            <h4 className="font-heading font-bold text-foreground mb-3 sm:mb-4 text-sm sm:text-base">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/shop" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                  Shop All
                </a>
              </li>
              <li>
                <a href="/shop?category=Anime" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                  Categories
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Social Media */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-center sm:text-left"
          >
            <h4 className="font-heading font-bold text-foreground mb-3 sm:mb-4 text-sm sm:text-base">Follow Us</h4>
            <div className="flex gap-3 sm:gap-4 justify-center sm:justify-start">
              <a
                href="https://www.instagram.com/posterly.io?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="bg-muted hover:bg-white hover:text-black text-foreground p-2.5 sm:p-3 rounded-sm transition-all hover:-translate-y-1"
                data-testid="footer-instagram-link"
                aria-label="Follow us on Instagram"
              >
                <InstagramLogo size={20} weight="fill" />
              </a>
              <button
                onClick={() => {
                  const url = getWhatsAppUrl((process.env.REACT_APP_WHATSAPP_NUMBER || '917416970039'), 'Hi, I have a question about Posterly posters!');
                  window.open(url, '_blank');
                }}
                className="bg-muted hover:bg-[#25D366] text-foreground p-2.5 sm:p-3 rounded-sm transition-all hover:-translate-y-1"
                data-testid="footer-whatsapp-link"
                aria-label="Contact us on WhatsApp"
              >
                <WhatsappLogo size={20} weight="fill" />
              </button>
            </div>
          </motion.div>
        </div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="border-t border-border/40 pt-6 sm:pt-8 text-center"
        >
          <p className="text-muted-foreground text-xs sm:text-sm">
            © {new Date().getFullYear()} Posterly. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
